import React from "react";

const TotalBillsPayedIcon = ({ width, height, color }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="6" fill="url(#paint0_linear_520_650)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.875 11.3721H30V25.1241C29.9974 26.4164 29.4829 27.655 28.5692 28.5688C27.6556 29.4826 26.4171 29.9972 25.125 29.9998H10V16.2478C10.002 14.9553 10.5162 13.7163 11.43 12.8023C12.3438 11.8884 13.5827 11.3741 14.875 11.3721Z"
        fill="#666666"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.855 24.0322H15.1362C14.9705 24.0322 14.8115 24.0981 14.6943 24.2153C14.5771 24.3325 14.5112 24.4915 14.5112 24.6573C14.5112 24.8231 14.5771 24.9821 14.6943 25.0993C14.8115 25.2166 14.9705 25.2824 15.1362 25.2824H24.8475C25.0133 25.2834 25.1726 25.2185 25.2905 25.102C25.4084 24.9855 25.4752 24.8269 25.4762 24.6611C25.4772 24.4953 25.4123 24.3359 25.2958 24.218C25.1793 24.1 25.0208 24.0332 24.855 24.0322Z"
        fill="#F4F4F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.855 26.3633H15.1362C14.9705 26.3633 14.8115 26.4291 14.6943 26.5464C14.5771 26.6636 14.5112 26.8226 14.5112 26.9884C14.5112 27.1542 14.5771 27.3132 14.6943 27.4304C14.8115 27.5476 14.9705 27.6135 15.1362 27.6135H24.8475C25.0133 27.6145 25.1726 27.5496 25.2905 27.433C25.4084 27.3165 25.4752 27.1579 25.4762 26.9921C25.4772 26.8263 25.4123 26.667 25.2958 26.549C25.1793 26.4311 25.0208 26.3643 24.855 26.3633Z"
        fill="#F4F4F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9936 18.9817C20.398 18.9824 20.7935 18.8631 21.1301 18.639C21.4667 18.4148 21.7292 18.0959 21.8845 17.7224C22.0397 17.349 22.0807 16.9379 22.0023 16.5411C21.9239 16.1444 21.7295 15.7798 21.4438 15.4936C21.1582 15.2073 20.794 15.0123 20.3975 14.9331C20.0009 14.8539 19.5898 14.8942 19.2161 15.0488C18.8425 15.2034 18.523 15.4654 18.2983 15.8016C18.0736 16.1378 17.9536 16.5332 17.9536 16.9376C17.9539 17.479 18.1689 17.9981 18.5513 18.3813C18.9337 18.7644 19.4523 18.9803 19.9936 18.9817ZM19.9936 16.0137C20.1771 16.0137 20.3564 16.0681 20.5089 16.17C20.6614 16.272 20.7803 16.4169 20.8505 16.5864C20.9207 16.7559 20.9391 16.9424 20.9033 17.1223C20.8675 17.3023 20.7792 17.4676 20.6495 17.5973C20.5197 17.727 20.3545 17.8154 20.1746 17.8512C19.9947 17.887 19.8082 17.8686 19.6387 17.7984C19.4692 17.7282 19.3243 17.6093 19.2224 17.4567C19.1205 17.3042 19.0661 17.1248 19.0661 16.9414C19.0664 16.6952 19.1642 16.4592 19.338 16.2849C19.5118 16.1106 19.7475 16.0122 19.9936 16.0112V16.0137Z"
        fill="#F4F4F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7703 23.1323C17.9178 23.132 18.0591 23.0733 18.1633 22.969C18.2675 22.8647 18.3263 22.7234 18.3266 22.576V22.1309C18.3266 21.688 18.5025 21.2631 18.8157 20.9499C19.1289 20.6366 19.5537 20.4607 19.9966 20.4607C20.4395 20.4607 20.8643 20.6366 21.1775 20.9499C21.4907 21.2631 21.6666 21.688 21.6666 22.1309V22.576C21.6666 22.7235 21.7252 22.865 21.8295 22.9694C21.9338 23.0737 22.0753 23.1323 22.2228 23.1323C22.3704 23.1323 22.5118 23.0737 22.6162 22.9694C22.7205 22.865 22.7791 22.7235 22.7791 22.576V22.1309C22.7791 21.393 22.486 20.6853 21.9643 20.1636C21.4426 19.6418 20.735 19.3486 19.9972 19.3486C19.2594 19.3486 18.5518 19.6418 18.0301 20.1636C17.5084 20.6853 17.2153 21.393 17.2153 22.1309V22.576C17.2157 22.7232 17.2742 22.8643 17.3782 22.9686C17.4822 23.0728 17.6231 23.1317 17.7703 23.1323Z"
        fill="#F4F4F4"
      />
      <path
        d="M23.1651 10H16.8264C16.7642 10 16.7139 10.0504 16.7139 10.1125V13.3567C16.7139 13.4189 16.7642 13.4693 16.8264 13.4693H23.1651C23.2272 13.4693 23.2776 13.4189 23.2776 13.3567V10.1125C23.2776 10.0504 23.2272 10 23.1651 10Z"
        fill="#808080"
      />
      <defs>
        <linearGradient
          id="paint0_linear_520_650"
          x1="20"
          y1="0"
          x2="20"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC5A9" />
          <stop offset="1" stopColor="#F79463" stopOpacity="0.94" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default TotalBillsPayedIcon;
